module.exports = __webpack_public_path__ + "img/friends.e7d7e5b1.svg";